"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPrivateHouse = function IconPrivateHouse(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M21 4v3h16.323l3.594 10.89h.453V18H43v6h-2v16.941q-.949.953-2 1.795V24H10v2H8v-2H6v-6h2.16v-.11h.15L11.854 7H15V4zm0 9V9h14.877l2.934 8.89H10.413L13.305 9H15v4h2V6h2v7zM9.762 19.89h29.709l.036.11H41v2H8v-2h1.726zm-.752 7.83c-2.396 0-4.42 4.72-4.42 7.73-.037 2.104 1.425 3.9 3.41 4.36v2.079q.957.855 2 1.607v-3.683a4.42 4.42 0 0 0 3.42-4.226v-.137c0-3.015-2.013-7.73-4.41-7.73m0 2c.304 0 .934.747 1.49 2.049.544 1.273.92 2.84.92 3.681v.12a2.41 2.41 0 0 1-2.457 2.355 2.415 2.415 0 0 1-2.373-2.457c0-.858.378-2.424.924-3.698.558-1.302 1.191-2.05 1.496-2.05M34 43V33h-6v10h1v-9h4v9zM18 29h5v7h-5zm4 6v-5h-3v5z",
    clipRule: "evenodd"
  })));
};

export { IconPrivateHouse, IconPrivateHouse as default };
